export const LINK_TO_INFO = 'https://epson.com/readyprint-terms'
